import t from 'tcomb';

export default t.interface({
  reward_redeemed_id: t.String
}, { strict: true, name: 'RedeemedReward' });

